var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_855_22144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7646 20C16.2875 20 20.7646 15.5228 20.7646 10C20.7646 4.47715 16.2875 0 10.7646 0C5.2418 0 0.764648 4.47715 0.764648 10C0.764648 15.5228 5.2418 20 10.7646 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83183 3.9118C2.04632 4.93379 1.45401 6.11172 1.10913 7.39137H6.3114L2.83183 3.9118Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4201 7.39137C20.0753 6.11176 19.4829 4.93383 18.6974 3.91183L15.218 7.39137H20.4201Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.10913 12.6087C1.45405 13.8884 2.04636 15.0663 2.83183 16.0882L6.31128 12.6087H1.10913Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8529 2.06722C15.8309 1.28172 14.653 0.689412 13.3734 0.34449V5.54672L16.8529 2.06722Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67645 17.9328C5.69844 18.7183 6.87637 19.3106 8.15598 19.6555V14.4533L4.67645 17.9328Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15594 0.34449C6.87634 0.689412 5.69841 1.28172 4.67645 2.06719L8.15594 5.54668V0.34449Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3734 19.6555C14.653 19.3106 15.8309 18.7183 16.8528 17.9328L13.3734 14.4533V19.6555Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.218 12.6087L18.6974 16.0883C19.4829 15.0663 20.0753 13.8884 20.4201 12.6087H15.218Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.68 8.69566H12.0691H12.069V0.0846484C11.642 0.0290625 11.2067 0 10.7646 0C10.3225 0 9.88727 0.0290625 9.46031 0.0846484V8.69559V8.69563H0.849297C0.793711 9.12262 0.764648 9.55793 0.764648 10C0.764648 10.4421 0.793711 10.8774 0.849297 11.3043H9.46023H9.46027V19.9154C9.88727 19.9709 10.3225 20 10.7646 20C11.2067 20 11.642 19.971 12.069 19.9154V11.3044V11.3044H20.68C20.7356 10.8774 20.7646 10.4421 20.7646 10C20.7646 9.55793 20.7356 9.12262 20.68 8.69566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3734 12.6088L17.8357 17.0711C18.0409 16.8659 18.2367 16.6514 18.4235 16.4291L14.6031 12.6087H13.3734V12.6088Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15599 12.6087H8.15591L3.6936 17.0711C3.89876 17.2763 4.11325 17.4721 4.3356 17.6589L8.15599 13.8384V12.6087Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15599 7.39137V7.39129L3.69365 2.92891C3.48841 3.13407 3.29263 3.34856 3.10583 3.5709L6.92626 7.39133H8.15599V7.39137Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3734 7.39137L17.8357 2.92894C17.6306 2.72371 17.4161 2.52793 17.1937 2.34117L13.3734 6.1616V7.39137Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_855_22144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.764648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkIcon);
export default __webpack_public_path__ + "static/media/uk-icon.de400ab6b546649aeaf388660cac2fb7.svg";
export { ForwardRef as ReactComponent };